import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  //Grid2,
  IconButton,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { notiError } from "../../utils/notiUltils";
import trophy from "../../images/trophy.png";
import { formatNumber } from "../modules";
import { ConfigProvider, Table } from "antd";
import { Close } from "@mui/icons-material";
import bg2 from "../../images/bg2.png";
import ApexCharts from "apexcharts";
import dayjs from "dayjs";

function MonthlyMaximumNotificationArea({ api, reloadData, setReloadData }) {
  const [dataSource, setDataSource] = useState({});
  const [status, setStatus] = useState(false);
  useEffect(() => {
    if (!api || !reloadData || !setReloadData) {
      return;
    }
    setStatus(false);
    api
      .get("/dashboard1", localStorage.getItem("token"))
      .then((data) => {
        setTimeout(() => {
          setDataSource(data);
          setStatus(true);
          setReloadData(false);
        }, 200);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });
  }, [api, reloadData, setReloadData]);

  return (
    <Card sx={{ p: 1, height: "100%" }}>
      <CardHeader
        title={dataSource?.locationName + "! 🎉"}
        titleTypographyProps={{ variant: "subtitle1", whiteSpace: "nowrap" }}
        subheader={"พื้นที่แจ้งเตือนสูงสุดประจำเดือน"}
        subheaderTypographyProps={{ variant: "caption", whiteSpace: "nowrap" }}
        sx={{ pb: 0 }}
      />
      <CardContent sx={{ pt: 0 }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack justifyContent={"center"} spacing={1.3}>
            <Stack>
              <Typography
                className={status ? "animate__animated animate__bounceIn" : ""}
                whiteSpace={"nowrap"}
                variant="h6"
              >
                {formatNumber(dataSource?.amount ?? 0)} ครั้ง
              </Typography>
              <Typography
                whiteSpace={"nowrap"}
                color="text.secondary"
                variant="caption"
              >
                {dataSource?.percent ?? 0}% ของการแจ้งเตือน 🚀
              </Typography>
            </Stack>
            <ShowAlert api={api} />
          </Stack>
          <Box>
            <img src={trophy} width={79} alt="" />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
export default MonthlyMaximumNotificationArea;

/*const style = {
  width: 760,
  //height:'100%',
  boxShadow: 24,
  p: 1,
  overflow: "auto",
  //background:
  //  "linear-gradient(180deg, rgba(255,255,255,1) 0%,rgba(255,255,255,1) 80%, rgb(181, 203, 238) 100%)",
};*/
function ShowAlert({ api }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [dataSource, setDataSource] = useState([]);
  const refChart = useRef(null);
  useEffect(() => {
    if (refChart.current) {
      refChart.current.destroy();
    }
    if (!open) {
      return;
    }

    api
      .get("/alertSumary", localStorage.getItem("token"))
      .then((data) => {
        setDataSource(data.data);
        setTimeout(() => {
          const series = data.data.map((a) => a.amount);
          const labels = data.data.map((a) => a.locationName);
          const options = {
            chart: {
              type: "pie",
              toolbar: {
                show: true,
                export: {
                  svg: {
                    filename: `pie_chart_${dayjs().format("YYYY-MM-DD HH-mm-ss")}`,
                  },
                  png: {
                    filename: `pie_chart_${dayjs().format("YYYY-MM-DD HH-mm-ss")}`,
                  },
                },
              },
            },
            series,
            labels,
          };
          const chart = new ApexCharts(
            document.querySelector("#chart_01"),
            options
          );
          chart.render();
          refChart.current = chart;
        }, 100);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });
  }, [api, open]);

  return (
    <>
      <Button
        sx={{ mt: 1, textTransform: "none" }}
        size="small"
        variant="contained"
        onClick={handleOpen}
      >
        แสดงการแจ้งเตือน
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"        
        //className={open ? "animate__animated animate__bounceIn" : ""}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card
          sx={{
            boxShadow: 24,
            p: 1,
            overflow: "auto",
            backgroundImage: `url(${bg2})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundColor: "#b4a0ff",
            backgroundRepeat: "no-repeat",
            minWidth:600
          }}
        >
          <CardHeader
            title={"พื้นที่แจ้งเตือนประจำเดือน"}
            titleTypographyProps={{ variant: "h6", component: "h2" }}
            subheader={"รายการแจ้งเตือนตามเขตพื้นที่"}
            subheaderTypographyProps={{ variant: "caption" }}
            action={
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            }
            //sx={{ bgcolor: blue[100] }}
          />
          <CardContent>
            <Card
              elevation={24}
              className="animate__animated animate__rotateInDownLeft"
            >
              <CardContent>
                <Box>
                  <div id="chart_01"></div>
                </Box>
                <AlarmTable dataSource={dataSource} />
              </CardContent>
            </Card>
          </CardContent>
        </Card>
      </Modal>
    </>
  );
}

function AlarmTable({ dataSource }) {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "kanit",
          colorBgContainer: "transparent",
        },
      }}
    >
      <Table
        dataSource={dataSource}
        bordered={true}
        pagination={{ pageSize: 5 }}
        //style={{background:"#FFF",borderRadius:4,overflow:'hidden'}}
        size="small"
        //sticky={true}
        columns={[
          {
            title: "ลำดับ",
            width: 80,
            //render: (a, b, c) => c + 1,
            render: (a, b, c) => (
              <Typography variant="caption" fontWeight={300}>
                {c + 1}
              </Typography>
            ),
            key: "no",
            align: "center",
          },
          {
            title: "ชื่อสถานที่",
            //dataIndex: "locationName",
            key: "LocationName",
            render: (a) => (
              <Typography variant="caption" fontWeight={300}>
                {a.locationName}
              </Typography>
            ),
          },
          {
            title: "หมวดหมู่",
            //dataIndex: "categoryName",
            key: "CategoryName",
            render: (a) => (
              <Typography variant="caption" fontWeight={300}>
                {a.categoryName}
              </Typography>
            ),
          },
          {
            align: "center",
            title: "จำนวนครั้ง",
            //dataIndex: "amount",
            render: (a) => (
              <Typography variant="caption" fontWeight={300}>
                {formatNumber(a.amount)} ครั้ง
              </Typography>
            ),
            key: "amount",
          },
          {
            align: "center",
            title: "เปอร์เซนต์",
            //width: 150,
            //dataIndex: "percent",
            render: (a) => (
              <Typography variant="caption" fontWeight={300}>
                {parseFloat(a.percen).toFixed(1)} %
              </Typography>
            ),
            /*render: (a) => (
              <Progress steps={10} size={"small"} percent={a.percen} />
            ),*/
            key: "percent",
          },
        ]}
      />
    </ConfigProvider>
  );
}
